// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingPage_container__2rOef"};